/**
 *
 * PluginIcon
 *
 */

import { Cloud } from '@strapi/icons';

const PluginIcon = () => <Cloud />;

export { PluginIcon };
